export class SpinLoader {
    constructor(requestParameters, spinnerClassName = 'spin-loader') {
        this.requestParameters = requestParameters;
        var obj = this;
        this.spinner.retryCallback = function() { 
            obj.spinner.show();//delay a bit before retry
            obj.spinner.clearError();
            (new Promise(r => setTimeout(r, 100))).then(() => {
                obj.fetch(); 
            });
            
        };
        this.spinner.className = spinnerClassName;
    }
    spinner = {
        className: 'spin-loader',
        enabled: true,
        showError: true,
        errorRetry: true,

        retryCallback: null,

        show: function () {
            let es = document.getElementsByClassName(this.className);
            [].forEach.call(es, function (e) {
                e.classList.remove('spinner-hide');
            });
            return this;
        },

        markError: function () {
            let es = document.getElementsByClassName(this.className);
            [].forEach.call(es, function (e) {
                e.classList.add('spinner-error');
            });
            return this;
        },
        hide: function () {
            let es = document.getElementsByClassName(this.className);
            [].forEach.call(es, function (e) {
                e.classList.add('spinner-hide');
                e.classList.remove('spinner-first');
            });
            return this;
        },
        clearError: function () {
            let es = document.getElementsByClassName(this.className);
            [].forEach.call(es, function (e) {
                e.classList.remove('spinner-error');
            });
            return this;
        }

    }
    fetching = false;
    onSuccess = null;
    onError = null;
    onComplete = null;
    requestParameters = {
        url: null,
        dataType: null,
        method: null,
        data: null
    }
    on = function (event, callback) {
        switch (event) {
            case 'success':
                this.onSuccess = callback;
                break;
            case 'error':
                this.onError = callback;
                break;
            case 'complete':
                this.onComplete = callback;
                break;
        }
        return this;
    }
    spinnerTemplate = function () {
        return '<div class="spinner-element lds-ring"><div></div><div></div><div></div></div>';
    }
    createSpinner() {
        var obj = this;
        var sp = $('<div>').addClass('spinner-container spinner-first').addClass(obj.spinner.className)
            .addClass(this.spinner.errorRetry ? 'spinner-retryable' : '') //retryable
            .append($('<div>').addClass('spinner-error-indicator').on('click', function (e) {
                if (obj.spinner.errorRetry && obj.spinner.enabled && (obj.spinner.retryCallback instanceof Function)) {
                    obj.spinner.retryCallback();
                    e.stopPropagation();
                    return false;
                }
            }).append($('<i>').addClass('fas fa-exclamation-triangle')))
            .append($('<div>').addClass('spinner-loading-indicator').append(obj.spinnerTemplate()));

        return sp;
    }
    putSpinnerByClassName(className) {
        var obj = this;
        $('.' + className).each(function (idx, e) {
            $(e).append(obj.createSpinner());
        });
        return this;
    }
    putSpinnerbyId(id) {
        $('#' + id).append(this.createSpinner());
        return this;
    }
    fetch() {

        var obj = this;

        if (obj.fetching)
            return;

        obj.fetching = true;

        //start spinner
        obj.spinner.show();

        $.ajax(this.requestParameters)
            .done(function (response) {
                if (obj.onSuccess instanceof Function)
                    obj.onSuccess(response);

                //hide spinner
                obj.spinner.hide();
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                if (obj.onError instanceof Function)
                    obj.onError(jqXHR, textStatus, errorThrown);

                obj.spinner.markError().show();
            })
            .always(function (response) {
                if (obj.onComplete instanceof Function)
                    obj.onComplete(response);

                obj.fetching = false;
            });

    }

}